import { SelectOption, Gender } from '../typings'
import { i18n } from '../localization'
import { enumToSelectOptions } from '../utilities/helpers'
import { App } from '../typings/api-enums'

// Selects
export function getAllCountries(): SelectOption<string>[] {
    return window.condaAllCountries
}

export function getSelectableCountryCodes(): SelectOption<string>[] {
    return getAllCountries().filter((country) => window.condaSelectableCountries.includes(country.key))
}

// gender options
export const genderOptions: SelectOption<Gender>[] = [
    {
        key: 'male',
        label: i18n.global.t('forms.radio_male'),
    },
    {
        key: 'female',
        label: i18n.global.t('forms.radio_female'),
    },
    {
        key: 'non-binary',
        label: i18n.global.t('forms.radio_non-binary'),
    },
]

export const yesNoOptions: SelectOption<string>[] = [
    {
        key: 'yes',
        label: i18n.global.t('forms.radio_yes'),
    },
    {
        key: 'no',
        label: i18n.global.t('forms.radio_no'),
    },
]

export const yesNoDenyOptions = enumToSelectOptions(App.Enums.ComplianceProfile.ECSP.YesNoDenyOption, 'yes_no_deny')

export const pepOptions: SelectOption<boolean>[] = [
    {
        key: true,
        label: i18n.global.t('forms.radio_yes'),
    },
    {
        key: false,
        label: i18n.global.t('forms.radio_no'),
    },
]
